/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddSupplyModel as DigiworkMaitreDPosDtoMenuAddSupplyModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Menu/add-supply-model';

export interface AddSupply_1$Params {
      body?: DigiworkMaitreDPosDtoMenuAddSupplyModel
}

export function addSupply_1(http: HttpClient, rootUrl: string, params?: AddSupply_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, addSupply_1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

addSupply_1.PATH = '/api/gmn/Supply/addsupply';
